import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { hasSubmitSucceeded, isSubmitting } from 'redux-form'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'

import { Checkbox, Input, InputPassword } from 'components/fields'
import { Form } from 'components/layout'
import { FormButton, Button, Module, Title } from 'components/misc'
import { LoaderOverlay } from 'components/loaders'
import { form } from 'helpers/decorators'
import { apiCommon, apiConfiguration, apiPasswords } from 'helpers/decorators/api'
import validate from './organization-contact-registration-form.validation'
import config from 'config'
import { Address, Contact, PersonalDetails } from '../../../../components/forms'
import queryString from 'query-string'
import { get } from 'lodash'
import { orgContactRegistrationInitialize } from '../../../../models'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import { ConfigurationFile, ConfigurationWrapper } from '../../../misc'
import styles from '../../leader/Account/account.styl'

const formName = 'organizationContactRegistrationForm'

@apiConfiguration()
@form({
  form: formName,
  disableHook: true,
  validate,
})
@apiPasswords()
@apiCommon({
  publicCountries: true,
//  publicRegions: true,
  fetchOnClient: true
})
@connect(
  state => ({
    isSubmitted: hasSubmitSucceeded(formName)(state),
    isSubmitting: isSubmitting(formName)(state)
  }),
  { push }
)
class OrganizationContactRegistrationForm extends Component {
  static propTypes = {
    pristine: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onConfirmOrganizationContactRegistration: PropTypes.func.isRequired,
    location: PropTypes.object,
    isSubmitting: PropTypes.bool,
    push: PropTypes.func,
    initialize: PropTypes.func.isRequired,
    getRegistrationInfo: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    organizationContactRegistration: PropTypes.object.isRequired,
    handleGetOrgContactRegistrationFieldsCustomization: PropTypes.func.isRequired,
    isConfigurationTrue: PropTypes.func.isRequired,
    errors: PropTypes.object
  }

  static defaultProps = {
    loading: false
  }

  componentDidMount = async() => {
    const {
      getRegistrationInfo
    } = this.props

    const query = queryString.parse(get(this.props, 'location.search'))

    const authorizationCode = get(query, 'authorizationCode')

    if (authorizationCode) {
      let body

      try {
        const res = await getRegistrationInfo(authorizationCode)

        body = JSON.parse(res.body) || {}

        const initData = orgContactRegistrationInitialize(body)

        if (initData.organizationId) {
          await this.props.handleGetOrgContactRegistrationFieldsCustomization(initData.organizationId)
        }

        this.props.initialize(initData)
        this.props.onInitialize()
      } catch (err) {
        const errorCode = get(err, 'body') && JSON.parse(err.body).errorCode

        if (errorCode === 'UNAUTHORIZED') {
          this.props.notification(
            'Authorisation code is not valid - it looks like you have previously used this code',
            {
              intlKey: 'notifications.authorization_code_is_not_valid',
              status: 'error',
            },
          )
          this.props.push(`${config.publicPath}/`)
        }
      }

      const volunteerCodeOfConductCfg = await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.volunteerCodeOfConduct.id, get(body, 'organization.id'), true)

      const isVolunteerCodeOfConductEnabled = get(volunteerCodeOfConductCfg, 'body.booleanValue', false)

      if (isVolunteerCodeOfConductEnabled) {
        await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.auCoConductDoc.id, get(body, 'organization.id'), true)
      }

      const naoRegRequirementCfg = await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.enableNaoRegRequirements.id, get(body, 'organization.id'), true)
      const isNaoRegRequirementEnabled = get(naoRegRequirementCfg, 'body.booleanValue', false)

      if (isNaoRegRequirementEnabled) {
        await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.naoRegRequirementsUrl.id, get(body, 'organization.id'), true)
      }

      const privacyPolicyAgreementCfg = await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id, get(body, 'organization.id'), true)
      const isPrivacyPolicyAgreementEnabled = get(privacyPolicyAgreementCfg, 'body.booleanValue', false)

      if (isPrivacyPolicyAgreementEnabled) {
        await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.privacyPolicyUrl.id, get(body, 'organization.id'), true)
      }

      await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.leaderMinAge.id, get(body, 'organization.id'), true)
    }
  }

  redirectToLogin = () => this.props.push(`${config.publicPath}/`)

  handleSubmit = fields =>
    this.props
      .onConfirmOrganizationContactRegistration(fields)
      .then(() => this.props.push(`${config.publicPath}/password-reset/success`))

  render() {
    const {
      handleSubmit,
      pristine,
      isSubmitting,
      location,
      codeLists,
      configuration,
      organizationContactRegistration,
      common,
      errors
    } = this.props

    const orgId = get(organizationContactRegistration, 'organization.id')

    const isSubmitted = location && location.pathname.includes('/success')

    const hasConductEnabled = get(configuration, `values[${CONFIGURATION_KEYS.volunteerCodeOfConduct.id}].booleanValue`)
    const conductUrl = get(configuration, `values[${CONFIGURATION_KEYS.auCoConductDoc.id}].fileUrl`)

    const isNaoRegRequirementEnabled = get(configuration, `values[${CONFIGURATION_KEYS.enableNaoRegRequirements.id}].booleanValue`)
    const naoRegRequirementUrl = get(configuration, `values[${CONFIGURATION_KEYS.naoRegRequirementsUrl.id}].textValue`)

    const isPrivacyPolicyAgreementEnabled = get(configuration, `values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`)
    const privacyPolicyUrl = get(configuration, `values[${CONFIGURATION_KEYS.privacyPolicyUrl.id}].textValue`)

    const minAgeCfg = get(configuration, `values[${CONFIGURATION_KEYS.leaderMinAge.id}].intValue`)

    const showDateOfBirth = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactDateOfBirth.id)

    const showSecondaryEmail = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactEmailAddress2.id)

    const showPhone = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactPhoneNumber.id)

    const showMiddleName = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactMiddleName.id)

    const showGender = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactGender.id)

    const showFirstLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine1.id)

    const showSecondLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine2.id)

    const showCity = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCity.id)

    const showZipCode = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressZipCode.id)

    const showRegion = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressRegion.id)

    const showCountry = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCountry.id)

    const showAddress = showFirstLine || showSecondLine || showCity || showZipCode || showRegion || showCountry

    return (
      <Module>
        <LoaderOverlay isLoading={isSubmitting}>
          <Form onSubmit={handleSubmit(this.handleSubmit)}>
            <h2 className='alpha nowrap'>
              <FormattedMessage
                id='moduleTitle.reset_password'
                defaultMessage='Reset Password'
              />
            </h2>

            <div className='row'>
              <div className='col-xs-12'>
                <Title h1>
                  <FormattedMessage
                    id='moduleTitle.personal_details'
                    defaultMessage='Personal Details'
                  />
                </Title>
                <PersonalDetails
                  titles={codeLists.titles.list}
                  genders={showGender && codeLists.genders.list}
                  isOrganizationContact
                  showMiddleName={showMiddleName}
                  minAgeCfg={minAgeCfg}
                  showDateOfBirth={showDateOfBirth}
                  errors={errors}
                />
              </div>
            </div>

            <div>
              <Title h2>
                <FormattedMessage
                  id='moduleTitle.contact_details'
                  defaultMessage='Contact Details'
                />
              </Title>
              <Contact
                isEmailDisabled
                confirmEmailAddress={false}
                phoneTypes={codeLists.phoneTypes.list}
                showSecondaryFields
                showSecondaryEmail={showSecondaryEmail}
                showPhoneNumber={showPhone}
                showPhoneType
                showSecondaryPhone={false}
                showSecondaryPhoneType={false}
              />
            </div>

            {showAddress && <div>
              <Title h2>
                <FormattedMessage
                  id='moduleTitle.home_address'
                  defaultMessage='Home Address'
                />
              </Title>
              <Address
                showFirstLine={showFirstLine}
                showSecondLine={showSecondLine}
                showCity={showCity}
                showZipCode={showZipCode}
                showRegion={showRegion}
                countries={showCountry && common.countries.list}
              />
            </div>}

            <div className='row'>
              <div className='col-xs-8'>
                {isSubmitted && (
                  <div>
                    <p className='delta text--center'>
                      <FormattedMessage
                        id='notifications.your_new_password_has_been_set'
                        defaultMessage='Your new password has been set'
                      />
                    </p>
                    <Button
                      type='button'
                      onClick={this.redirectToLogin}
                      simple
                      fluid
                    >
                      <FormattedMessage
                        id='moduleTitle.login'
                        defaultMessage='Log in'
                      />
                    </Button>
                  </div>
                )}

                {!isSubmitted && [
                  <InputPassword
                    name='password'
                    type='password'
                    label='Password'
                    intlKey='label.password'
                  />,
                  <Input
                    name='passwordVerify'
                    type='password'
                    label='Password again'
                    intlKey='label.password_again'
                  />,

                ]}
              </div>
            </div>

            <div className='row'>
              <div className='col-xs-12'>

                <div style={{ float: 'left' }}>
                  <Checkbox
                    name='terms'
                    label="I have read the <a href='{url}' target='_blank'>Terms and conditions and agree with them."
                    intlKey='label.i_have_read_the_terms_and_conditions'
                    intlValues={{
                      url: '/orb_parental_consent_form.pdf',
                    }}
                  />
                </div>
                <div style={{ float: 'left', marginTop: 1, marginLeft: 5 }}>
                  <ConfigurationFile
                    configKey={CONFIGURATION_KEYS.termsAndConditionsLeader.id}
                    organizationId={orgId}
                    isPublic
                    formattedName={
                      <FormattedMessage
                        id='button.terms_and_conditions'
                        defaultMessage='International Terms & Conditions'
                      />
                    }
                  />
                </div>
                <div style={{ clear: 'both' }}></div>
                <div className={styles.agreementsWrapper}>
                  {hasConductEnabled &&
                    conductUrl &&
                    <Checkbox
                      name='agreementCodeOfConduct'
                      label='I Agree to Volunteer Code of Conduct.'
                      intlKey='label.i_agree_to_volunteer_code'
                      intlValues={{
                        url: conductUrl,
                      }}
                    />}

                  {
                    isNaoRegRequirementEnabled &&
                    naoRegRequirementUrl &&
                    <Checkbox
                      name='naa'
                      label="I confirm that I meet all NAA Regulation Requirements. <a href='{url}' target='_blank'>For more information click here.</a>"
                      intlKey='label.i_confirm_that_i_meet'
                      intlValues={{
                        url: naoRegRequirementUrl,
                      }}
                    />}

                  {isPrivacyPolicyAgreementEnabled &&
                    privacyPolicyUrl &&
                    <Checkbox
                      name='agreementPrivacyPolicy'
                      label="I have read the Privacy Policy and agree with. <a href='{url}' target='_blank'>The Privacy Policy is here.</a>"
                      intlKey='label.i_agree_to_privacy_policy'
                      intlValues={{
                        url: privacyPolicyUrl,
                      }}
                    />}

                  <ConfigurationWrapper
                    configKey={CONFIGURATION_KEYS.marketingMaterialsFromNao.id}
                    type='booleanValue'
                    orgId={orgId}
                  >
                    <Checkbox
                      name='marketingFromNao'
                      label='Opt in to receive marketing materials from the NAO.'
                      intlKey='label.marketing_from_nao'
                    />
                  </ConfigurationWrapper>
                  <ConfigurationWrapper
                    configKey={CONFIGURATION_KEYS.marketingMaterialsFromOa.id}
                    type='booleanValue'
                    orgId={orgId}
                  >
                    <Checkbox
                      name='marketingFromOa'
                      label='Opt in to receive marketing materials from the Operating Authority.'
                      intlKey='label.marketing_from_oa'
                    />
                  </ConfigurationWrapper>
                  <ConfigurationWrapper
                    configKey={CONFIGURATION_KEYS.marketingMaterialsFromIaf.id}
                    type='booleanValue'
                    orgId={orgId}
                  >
                    <Checkbox
                      name='marketingFromIaf'
                      label='Opt in to receive marketing materials from the International Foundation.'
                      intlKey='label.marketing_from_iaf'
                    />
                  </ConfigurationWrapper>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-xs-2'>
                <FormButton
                  pristine={pristine}
                  simple
                  fluid
                  isLoading={isSubmitting}
                >
                  <FormattedMessage id='button.send' defaultMessage='Send' />
                </FormButton>
              </div>
            </div>

          </Form>
        </LoaderOverlay>
      </Module>
    )
  }
}

export default OrganizationContactRegistrationForm
